import { jsxs as s, jsx as c, Fragment as S } from "react/jsx-runtime";
import { useId as N } from "react";
import { c as r } from "./clsx-OuTLNxxd.js";
const z = "320px", B = "600px", T = "1025px", w = "_isVisuallyHidden_1hk17_51", I = "_performanceIndicator_1hk17_63", M = "_container_1hk17_67", P = "_percentage_1hk17_79", $ = "_label_1hk17_87", O = "_indicatorWrapper_1hk17_94", v = "_hasMaxWidth_1hk17_102", F = "_indicator_1hk17_94", R = "_success_1hk17_113", j = "_failure_1hk17_117", A = "_neutral_1hk17_121", C = "_dateTop_1hk17_125", V = "_dateBottom_1hk17_126", L = "_teamName_1hk17_142", t = {
  mobile: z,
  "mobile-wide": "480px",
  tablet: B,
  "tablet-wide": "800px",
  desktop: T,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  isVisuallyHidden: w,
  performanceIndicator: I,
  container: M,
  "spacing-s": "_spacing-s_1hk17_73",
  "spacing-m": "_spacing-m_1hk17_76",
  percentage: P,
  label: $,
  indicatorWrapper: O,
  hasMaxWidth: v,
  indicator: F,
  success: R,
  failure: j,
  neutral: A,
  dateTop: C,
  dateBottom: V,
  teamName: L
}, D = ({
  formatDate: o,
  hasMaxWidth: p = !0,
  history: x,
  hitRate: f,
  label: d,
  showMatchInformation: m = !1,
  showHitRate: u = !0,
  position: _ = "end",
  spacing: W = "m",
  className: b
}) => {
  const h = (e) => {
    const i = new Date(e), n = i.getMonth() + 1, a = i.getDate();
    return `${n}/${a}`;
  }, g = (e, { showFullName: i } = {}) => {
    const n = e.participant.side === "AWAY", a = n ? e.homeTeam : e.awayTeam, l = i ? a.name : a.shortName;
    return n ? `@${l}` : l;
  };
  function H(e) {
    const i = e.reduce((a, l) => l.participant.betResult === "WON" ? a + 1 : a, 0);
    return Math.round(i / e.length * 100);
  }
  const k = (e) => {
    switch (e) {
      case "WON":
        return t.success;
      case "LOST":
        return t.failure;
      default:
        return t.neutral;
    }
  }, y = N();
  return /* @__PURE__ */ s("div", { className: r(t.performanceIndicator, b), children: [
    d && /* @__PURE__ */ c("label", { className: t.label, htmlFor: y, children: d }),
    /* @__PURE__ */ s(
      "div",
      {
        className: r(t.container, t[`spacing-${W}`]),
        id: y,
        role: "group",
        "aria-label": "Performance Indicator",
        style: {
          "--indicator-count": x.length,
          justifyContent: _ === "start" ? "flex-end" : "flex-start"
        },
        children: [
          u && /* @__PURE__ */ s("span", { className: t.percentage, "data-testid": "hit-rate", children: [
            f || H(x),
            "%"
          ] }),
          x.map((e, i) => {
            const n = k(e.participant.betResult);
            return /* @__PURE__ */ s(
              "div",
              {
                className: r(t.indicatorWrapper, {
                  [t.hasMaxWidth]: p
                }),
                "data-testid": "indicator",
                children: [
                  m && /* @__PURE__ */ c("span", { className: t.dateTop, "data-testid": "date-top", children: o ? o(e.startTime, "M/d") : h(e.startTime) }),
                  /* @__PURE__ */ c(
                    "div",
                    {
                      className: r(t.indicator, n),
                      role: "img",
                      "aria-label": `${e.participant.betResult === "WON" ? "Success" : e.participant.betResult === "LOST" ? "Failure" : "Undetermined"} against ${g(e)}`
                    }
                  ),
                  m && /* @__PURE__ */ s(S, { children: [
                    /* @__PURE__ */ c("span", { className: t.teamName, children: g(e) }),
                    /* @__PURE__ */ c("span", { className: t.dateBottom, "data-testid": "date-bottom", children: o ? o(e.startTime, "M/d") : h(e.startTime) })
                  ] })
                ]
              },
              i
            );
          })
        ]
      }
    )
  ] });
};
export {
  D as P
};
